import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNetworkAccessList } from "actions/network";
import { SelectWifiNetwork } from "empower-energy-owner-components";

const SelectWifiNetworkModal = ({
  selectedUnit,
  onCancel,
  onClickSelectWifiNetwork,
}) => {
  const dispatch = useDispatch();

  // Memoize fetchNetworkList for consistent function reference and deps
  const fetchNetworkList = useCallback(() => {
    if (selectedUnit?.id) {
      dispatch(getNetworkAccessList(selectedUnit.id));
    }
  }, [dispatch, selectedUnit]);

  // Fetch list when modal is opened or selectedUnit changes
  useEffect(() => {
    fetchNetworkList();
  }, [fetchNetworkList]);

  // Selectors for network access/loading/settings
  const loading = useSelector((state) => state.network?.networkAccessLoading);
  const list = useSelector((state) => state.network?.networkAccessList || []);
  const networkSettings = useSelector(
    (state) => state.network?.networkSettings,
  );

  return (
    <SelectWifiNetwork
      loading={loading}
      list={list}
      networkSettings={networkSettings}
      onCancel={onCancel}
      onClickSelectWifiNetwork={onClickSelectWifiNetwork}
      onClickSearch={fetchNetworkList}
    />
  );
};

export default SelectWifiNetworkModal;
